import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import {
  BackgroundWithCurve,
  CaseStudiesImageCard,
  CaseStudyHeading,
  Section,
} from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const KarnatakaTourism = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Karnataka Tourism',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Tourism and Hospitality',
                path: '/industries/tourism-hospitality',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-white shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-32 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.KarnatakaTourismLogo ? (
                <img
                  className="h-16 w-16 md:h-16 md:w-16 lg:h-20 lg:w-20 object-contain"
                  src={imagePath?.KarnatakaTourismLogo}
                  alt="Karnataka Tourism Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Karnataka Tourism"
                desc="Immersive AR Heritage Experience for Karnataka Tourism"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {videoPath?.KarnatakaTourismVideo && (
                <video
                  src={videoPath?.KarnatakaTourismVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            subtitle="Recreating Vittala Temple Through Spatial Grid"
            content="Karnataka Tourism partnered with Spatial Grid to bring two of Hampi’s most iconic cultural landmark—
            the Vittala Temple, renowned for its legendary stone chariot—into an immersive, interactive AR experience. 
            The goal was to help visitors, students, and global audiences explore these UNESCO World Heritage 
            structures with deeper context, guided storytelling, and interactive touchpoints accessible directly from 
            their smartphones."
          />
          <Section
            title="Objective"
            content={[
              'Karnataka Tourism sought a modern way to showcase the architectural brilliance and historical significance of Hampi’s world-renowned heritage sites. They wanted visitors to explore these monuments both remotely and on-location, while preserving cultural narratives in an accessible, interactive format. The goal was to make tourism more educational and engaging, especially for audiences unfamiliar with the history of Hampi. Spatial Grid was selected to create a high-fidelity AR experience that could be launched instantly via a simple QR scan, without the need for app downloads or specialized hardware.',
            ]}
          />

          <Section
            title="Solution"
            content={[
              'Spatial Grid developed a fully web-based AR experience that recreated the Virupaksha Temple and Vittala Temple in stunning 3D detail. By scanning a QR code, users could bring life-sized interactive models of the temples into their surroundings, allowing them to walk around the structures, view intricate carvings, and explore the environment at their own pace.',
              'The experience included high-fidelity 3D reconstructions that captured carvings, pillars, courtyards, gopurams, and the iconic Stone Chariot with exceptional accuracy. Interactive touchpoints were embedded throughout the models, enabling users to discover historical facts, architectural insights, cultural stories, and guided audio narration. Spatial storytelling brought each monument to life by explaining the rituals of the living Virupaksha Temple and the engineering marvels behind the Vittala Temple’s famed musical pillars.Because the AR experience ran entirely in the browser, it required no installation and was accessible to tourists, students, and international audiences alike. It was optimized for smooth performance across mobile devices, tablets, and even on-site kiosks, ensuring broad usability.',
            ]}
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.KarnatakaTourism1}
                title="AR/MR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.KarnatakaTourism2}
                title="Virtual Heritage & Destination Showcase"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content={[
                'The AR experience transformed the way visitors and learners engaged with Karnataka’s cultural heritage. It increased cultural awareness through intuitive storytelling and significantly boosted engagement at tourism booths and exhibitions. The solution also made heritage exploration more inclusive by allowing remote audiences to experience Hampi’s monuments from anywhere in the world. Digital documentation of the temples supported preservation efforts, while the interactive format provided strong educational value for schools, universities, and history enthusiasts studying Indian architecture and culture.',
                'By combining centuries-old heritage with immersive digital technology, Spatial Grid enabled Karnataka Tourism to offer a richer, more memorable experience—bringing iconic monuments to life in a way that is informative, accessible, and emotionally resonant.',
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default KarnatakaTourism;
